import React, { FC, useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid, Theme, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { UpdateBusinessEntitySettingsRequestDto } from '@sparling/financial-common'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { makeStyles } from '@mui/styles'
import { updateBusinessEntitySettingsRequest } from '../../../../store/actions'
import { getBusinessEntityDetailsData } from '../../../../store/selectors'
import { Modal } from '../../../../components/Modal'
import { InputField } from '../../../../components/InputField'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(4),
  },
  inputWrap: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  chip: {
    color: theme.palette.primary.light,
  },
}))

interface UpdateBusinessEntitySettingsModalProps {
  id: string
  isOpen: boolean
  modalClose: () => void
}

export const UpdateBusinessEntitySettingsModal: FC<UpdateBusinessEntitySettingsModalProps> = ({
  id,
  isOpen,
  modalClose,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const entity = useSelector(getBusinessEntityDetailsData)

  const formMethods = useForm<UpdateBusinessEntitySettingsRequestDto>({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: classValidatorResolver(UpdateBusinessEntitySettingsRequestDto),
    defaultValues: {
      b2c2: entity?.settings.b2c2,
      fireblocks: entity?.settings.fireblocks,
    },
  })
  const {
    handleSubmit,
    getValues,
    formState: { isValid },
  } = formMethods

  const onSubmit = useCallback(() => {
    dispatch(updateBusinessEntitySettingsRequest({ id, ...getValues() }))
    modalClose()
  }, [dispatch, id, getValues, modalClose])

  return (
    <Modal
      title={'Update Business Entity Users'}
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitDisabled={!isValid}
      width={600}
    >
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container className={classes.container}>
            <Grid item container className={classes.inputWrap}>
              <Typography variant="h3">Fireblocks Settings</Typography>
              <InputField inputName={'fireblocks.apiUrl'} labelName={'API URL'} inputType={'text'} fullWidth />
              <InputField inputName={'fireblocks.apiKey'} labelName={'API Key'} inputType={'text'} fullWidth />
              <InputField
                inputName={'fireblocks.privateKey'}
                labelName={'Private Key'}
                inputType={'text'}
                multiline
                rows={3}
                withoutPadding
                fullWidth
              />
            </Grid>
            <Grid item container className={classes.inputWrap}>
              <Typography variant="h3">B2C2 Settings</Typography>
              <InputField inputName={'b2c2.apiToken'} labelName={'API Token'} inputType={'text'} fullWidth />
              <InputField inputName={'b2c2.apiUrl'} labelName={'API URL'} inputType={'text'} fullWidth />
              <InputField inputName={'b2c2.wsApiUrl'} labelName={'WebSocket API URL'} inputType={'text'} fullWidth />
            </Grid>
          </Grid>
        </form>
      </FormProvider>
    </Modal>
  )
}
